module.exports = __webpack_public_path__ + "img/20191126163451962.1dc5778d.jpg";